// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import QuestionMarkCircle20 from './QuestionMarkCircle20.tsx';
import QuestionMarkCircle20Filled from './QuestionMarkCircle20Filled.tsx';
import QuestionMarkCircle24 from './QuestionMarkCircle24.tsx';
import QuestionMarkCircle24Filled from './QuestionMarkCircle24Filled.tsx';
import QuestionMarkCircle40 from './QuestionMarkCircle40.tsx';
import QuestionMarkCircle40Filled from './QuestionMarkCircle40Filled.tsx';
import QuestionMarkCircle48 from './QuestionMarkCircle48.tsx';
import QuestionMarkCircle48Filled from './QuestionMarkCircle48Filled.tsx';

type QuestionMarkCircleProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    QuestionMarkCircle20,
    QuestionMarkCircle20Filled,
    QuestionMarkCircle24,
    QuestionMarkCircle24Filled,
    QuestionMarkCircle40,
    QuestionMarkCircle40Filled,
    QuestionMarkCircle48,
    QuestionMarkCircle48Filled,
};

const QuestionMarkCircle: FC<QuestionMarkCircleProps> = ({ variation, ...props }) => {
    const variationKey = `QuestionMarkCircle${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"QuestionMarkCircle" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default QuestionMarkCircle;
